import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { MenuItem } from "primeng/api";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { ApeDrawerComponent } from "../ape-drawer/ape-drawer.component";
import { ApeButtonComponent } from "../ape-button/ape-button.component";
import { ApeMultiSelectComponent } from "../ape-multi-select/ape-multi-select.component";
import { TRANSLATION_KEYS } from "src/app/constants/translations/translation-keys";
import { UserMenuItem } from "src/app/constants/utils-type";

/**
 * Sidenav filtri del monitoraggio Goal Setting. Tutti i filtri sono a selezione multipla.
 */
@Component({
  selector: "ape-monitoring-goal-setting-details-filter-drawer",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe,
    ApeDrawerComponent,
    ApeButtonComponent,
    ApeMultiSelectComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./ape-monitoring-goal-setting-details-filter-drawer.component.html"
})
export class ApeMonitoringGoalSettingDetailsFilterDrawerComponent {
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  @Input({ required: true }) visible!: boolean;

  @Input() title: string = "";

  @Input() activeFiltersCount: number = 0;

  @Input() cardStatusOptions: MenuItem[] = [];

  @Input() proposalStatusOptions: MenuItem[] = [];

  @Input() updatesOptions: MenuItem[] = [];

  @Input() scorecardTypeOptions: MenuItem[] = [];

  @Input() managerOptions: UserMenuItem[] = [];

  @Input() departmentOptions: MenuItem[] = [];

  @Input() selectedCardStatuses: MenuItem[] = [];

  @Input() selectedProposalStatuses: MenuItem[] = [];

  @Input() selectedUpdates: MenuItem[] = [];

  @Input() selectedScorecardTypes: MenuItem[] = [];

  @Input() selectedManagers: UserMenuItem[] = [];

  @Input() selectedDepartments: MenuItem[] = [];

  @Input() cancelLabel: string = "generic.CANCEL";

  @Input() confirmLabel: string = "";

  @Output() onCancel = new EventEmitter<void>();

  @Output() onConfirm = new EventEmitter<void>();

  @Output() cardStatusesChange = new EventEmitter<MenuItem[]>();

  @Output() proposalStatusesChange = new EventEmitter<MenuItem[]>();

  @Output() updatesChange = new EventEmitter<MenuItem[]>();

  @Output() scorecardTypesChange = new EventEmitter<MenuItem[]>();

  @Output() managersChange = new EventEmitter<UserMenuItem[]>();

  @Output() departmentsChange = new EventEmitter<MenuItem[]>();

  @Output() onResetFilters = new EventEmitter<void>();

  protected onCardStatusesChange(selected: MenuItem[]): void {
    this.selectedCardStatuses = selected;
    this.cardStatusesChange.emit(selected);
  }

  protected onProposalStatusesChange(selected: MenuItem[]): void {
    this.selectedProposalStatuses = selected;
    this.proposalStatusesChange.emit(selected);
  }

  protected onUpdatesChange(selected: MenuItem[]): void {
    this.selectedUpdates = selected;
    this.updatesChange.emit(selected);
  }

  protected onScorecardTypesChange(selected: MenuItem[]): void {
    this.selectedScorecardTypes = selected;
    this.scorecardTypesChange.emit(selected);
  }

  protected onManagersChange(selected: MenuItem[] | UserMenuItem[]): void {
    this.selectedManagers = selected as UserMenuItem[];
    this.managersChange.emit(selected as UserMenuItem[]);
  }

  protected onDepartmentsChange(selected: MenuItem[]): void {
    this.selectedDepartments = selected;
    this.departmentsChange.emit(selected);
  }

  protected onResetClick(): void {
    this.selectedCardStatuses = [];
    this.selectedProposalStatuses = [];
    this.selectedUpdates = [];
    this.selectedScorecardTypes = [];
    this.selectedManagers = [];
    this.selectedDepartments = [];
    this.onResetFilters.emit();
  }

  protected onCancelClick(): void {
    this.onCancel.emit();
  }

  protected onConfirmClick(): void {
    this.onConfirm.emit();
  }
}
